import React from 'react';
import { Typography } from 'fronton-react';
import { useTranslation } from 'react-i18next';
import { OtzyvyFormBestPriceIcon } from 'common/icons/otzyvy-form-best-price-icon';
import { BestPriceIconContainer, bestPriceContainer } from './styles';

export const ProductBestPriceNameplate = () => {
  const { t } = useTranslation();

  return (
    <div className={bestPriceContainer} data-qa="product-best-price-nameplate">
      <BestPriceIconContainer>
        <OtzyvyFormBestPriceIcon />
      </BestPriceIconContainer>
      <Typography variant="caption_accent">{t('product-card.best-price')}</Typography>
    </div>
  );
};
